/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Reason_ExpensiveInputs */

const en_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too expensive`)
};

const de_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu teuer`)
};

const fr_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop cher`)
};

const es_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiado caro`)
};

const it_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppo caro`)
};

const nl_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te duur`)
};

const pl_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Za drogie`)
};

const fi_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liian kallis`)
};

const da_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For dyrt`)
};

const sv_cancel_reason_expensive = /** @type {(inputs: Cancel_Reason_ExpensiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För dyrt`)
};

/**
* | output |
* | --- |
* | "Too expensive" |
*
* @param {Cancel_Reason_ExpensiveInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_reason_expensive = /** @type {((inputs?: Cancel_Reason_ExpensiveInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Reason_ExpensiveInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_reason_expensive(inputs)
	if (locale === "fr") return fr_cancel_reason_expensive(inputs)
	if (locale === "es") return es_cancel_reason_expensive(inputs)
	if (locale === "it") return it_cancel_reason_expensive(inputs)
	if (locale === "nl") return nl_cancel_reason_expensive(inputs)
	if (locale === "pl") return pl_cancel_reason_expensive(inputs)
	if (locale === "fi") return fi_cancel_reason_expensive(inputs)
	if (locale === "da") return da_cancel_reason_expensive(inputs)
	if (locale === "sv") return sv_cancel_reason_expensive(inputs)
	return en_cancel_reason_expensive(inputs)
});